// extracted by mini-css-extract-plugin
export default {"imageContainer":"R_-z","summaryPar":"S_-z","ratingCategories":"T_-z","reviewerInfo":"U_-z","reviewTypes":"V_-z","expanded":"W_-z"};